import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

const subNavItems = [
  { path: '/evals', label: 'Evaluations', exact: true },
];

export function EvalsSubNav() {
  const location = useLocation();

  // Find the current tab based on path
  const currentTab = subNavItems.find((item) => {
    if (item.exact) {
      return location.pathname === item.path;
    }
    return location.pathname.startsWith(item.path);
  })?.path || '/evals';

  return (
    <div className="border-b bg-muted/30">
      <div className="container max-w-6xl">
        <Tabs value={currentTab}>
          <TabsList className="bg-transparent h-10 p-0 gap-4">
            {subNavItems.map((item) => (
              <TabsTrigger
                key={item.path}
                value={item.path}
                asChild
                className={cn(
                  'h-10 px-3 rounded-none border-b-2 border-transparent',
                  'data-[state=active]:border-primary data-[state=active]:bg-transparent',
                  'data-[state=active]:shadow-none',
                  'text-sm'
                )}
              >
                <Link to={item.path}>{item.label}</Link>
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
      </div>
    </div>
  );
}

export default EvalsSubNav;
